import { ErrorResponse } from './../../../models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { PropertiesService } from './../../../services/properties.service';
import { Property } from './../../../models/property.model';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ID } from '../../../models/ID.model';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss']
})
export class PropertyDetailsComponent implements OnInit {

    property?: Property;

    constructor(
        private propertiesService: PropertiesService,
        private utilsService: UtilsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getProperty(params.id);
            }
        });
    }

    getProperty(id: ID) {
        this.propertiesService.getPropertyById(id).subscribe(property => {
            this.property = property;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles de la propiedad', error.error?.descripcion));
    }
}
